import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "mb-6 flex flex-wrap items-end gap-3" }
const _hoisted_4 = { class: "flex flex-col gap-1.5" }
const _hoisted_5 = { class: "relative" }
const _hoisted_6 = { class: "flex flex-col gap-1.5" }
const _hoisted_7 = { class: "flex flex-col gap-1.5" }
const _hoisted_8 = { class: "flex flex-col gap-1.5" }
const _hoisted_9 = { class: "flex flex-col gap-1.5" }
const _hoisted_10 = {
  key: 0,
  class: "truncate"
}
const _hoisted_11 = {
  key: 1,
  class: "text-zinc-400"
}
const _hoisted_12 = { class: "space-y-1.5" }
const _hoisted_13 = { class: "flex items-center gap-2" }
const _hoisted_14 = { class: "space-y-1.5" }
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = { class: "space-y-1.5" }
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "flex justify-between pt-1" }
const _hoisted_19 = { class: "mb-6 flex items-center justify-between" }
const _hoisted_20 = { class: "text-sm text-zinc-400" }
const _hoisted_21 = { class: "flex items-center gap-2" }
const _hoisted_22 = { class: "text-sm font-medium text-white" }
const _hoisted_23 = { class: "text-sm font-medium text-white" }
const _hoisted_24 = { class: "text-sm font-medium text-white" }
const _hoisted_25 = { class: "text-sm font-medium text-white" }
const _hoisted_26 = { class: "text-sm text-zinc-300" }
const _hoisted_27 = { class: "text-sm text-zinc-300" }
const _hoisted_28 = { class: "flex items-center gap-1" }
const _hoisted_29 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_30 = { class: "flex flex-col" }
const _hoisted_31 = { class: "text-white font-bold text-lg" }
const _hoisted_32 = { class: "flex items-center gap-1" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = { class: "flex items-center justify-between pt-2" }
const _hoisted_37 = { class: "flex flex-col" }
const _hoisted_38 = { class: "text-sm font-medium text-white" }
const _hoisted_39 = { class: "flex flex-col items-end" }
const _hoisted_40 = { class: "grid grid-cols-2 gap-2 pt-2" }
const _hoisted_41 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_42 = {
  key: 0,
  class: "py-4"
}
const _hoisted_43 = { class: "flex items-center justify-between mb-4" }
const _hoisted_44 = { class: "flex items-center gap-2" }
const _hoisted_45 = { class: "overflow-x-auto" }
const _hoisted_46 = { class: "text-sm font-medium text-white truncate" }
const _hoisted_47 = {
  key: 0,
  class: "text-zinc-300"
}
const _hoisted_48 = {
  key: 1,
  class: "text-zinc-400"
}
const _hoisted_49 = { class: "flex items-center gap-1" }
const _hoisted_50 = { class: "space-y-1.5" }
const _hoisted_51 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_52 = {
  key: 0,
  class: "py-3 text-center text-sm text-zinc-400"
}
const _hoisted_53 = {
  key: 1,
  class: "py-3 text-center text-sm text-zinc-500"
}
const _hoisted_54 = { class: "space-y-1.5" }
const _hoisted_55 = { class: "flex gap-2 flex-wrap items-center px-3" }
const _hoisted_56 = { class: "space-y-1.5" }
const _hoisted_57 = { class: "space-y-1.5" }
const _hoisted_58 = {
  key: 0,
  class: "rounded-lg bg-zinc-800/60 border border-zinc-700 px-4 py-3 text-sm text-zinc-300"
}
const _hoisted_59 = { class: "text-white font-semibold" }
const _hoisted_60 = { class: "text-white font-semibold" }
const _hoisted_61 = { class: "text-white font-semibold" }
const _hoisted_62 = { class: "flex justify-end gap-3 pt-2" }
const _hoisted_63 = { class: "flex justify-end gap-3 pt-4" }

import { ref, onMounted, watch, computed } from 'vue'
import { useRouter } from 'vue-router'
import { ArrowsUpDownIcon } from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { Lead as ILead } from '@/interfaces/Lead'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { useToast } from '@/components/ui/toast'
import { Calendar as CalendarIcon, Contact, CreditCard, Eye, Loader2, MessageCircle, Plus, PlusCircle, RefreshCw, Search, ShieldOff, X } from 'lucide-vue-next'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { GetAllLeadsParams, useLead } from '@/composables/useLeads'
import LeadStatusBadge from '@/components/ui/badge/LeadStatusBadge.vue'
import { Button } from '@/components/ui/button'
import { Dialog, DialogScrollContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import StatusBadge from '@/components/ui/badge/StatusBadge.vue'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useGroup } from '@/composables/useGroup'
import { usePaymentPlan } from '@/composables/usePaymentPlan'
import { useGroupSubscription } from '@/composables/useGroupSubscription'
import { Group } from '@/interfaces/Group'
import { PaymentPlan } from '@/interfaces/PaymentPlan'
import { ComboboxAnchor, ComboboxContent, ComboboxInput, ComboboxPortal, ComboboxRoot } from 'radix-vue'
import { CommandEmpty, CommandGroup, CommandItem, CommandList } from '@/components/ui/command'
import { TagsInput, TagsInputInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText } from '@/components/ui/tags-input'


export default /*@__PURE__*/_defineComponent({
  __name: 'ManageLeadsView',
  setup(__props) {

const router = useRouter()
const { toast } = useToast()

// Table headers
const tableHeaders = [
  { key: 'firstName', label: 'Nome', sortable: false },
  { key: 'lastName', label: 'Sobrenome', sortable: false },
  { key: 'username', label: 'Usuário', sortable: false },
  { key: 'isBuyer', label: 'Comprador' },
  { key: 'groupSubscription', label: 'Assinatura de grupo' },
  { key: 'joinedAt', label: 'Data de entrada' },
  { key: 'lastPaymentAt', label: 'Último pagamento' },
  { key: 'exitAt', label: 'Saída' },
  { key: 'actions', label: '', class: 'w-40' },
]

function formatDate(date?: string | Date) {
  if (!date) return '—'
  return new Date(date).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

const groupSubscriptionTableHeaders = [
  { key: 'group', label: 'Grupo' },
  { key: 'expiresAt', label: 'Expiração' },
  { key: 'hasAccess', label: 'Acesso' },
  { key: 'actions', label: 'Ações' },
]

// Composables
const { getAll: getAllLeads, getById } = useLead()
const { getAll: getAllGroups } = useGroup()
const { getAll: getAllPaymentPlans } = usePaymentPlan()
const { createManual, renew, revoke } = useGroupSubscription()

// Data
const leads = ref<IPagination<ILead>>()
const groups = ref<IPagination<Group>>()
const paymentPlans = ref<IPagination<PaymentPlan>>()

// Pagination
const perPage = ref('10')

// Filters
const filterSearch = ref('')
const filterGroupId = ref('0')
const filterPaymentPlanId = ref('0')
const filterSubscriptionStatus = ref<'all' | 'active' | 'inactive'>('all')
const activeGroupId = ref<number | undefined>()
const activePaymentPlanId = ref<number | undefined>()
const activeSubscriptionStatus = ref<'active' | 'inactive' | undefined>()

// Date range filters (yyyy-mm-dd strings, from <input type="date">)
const filterJoinedAtFrom = ref('')
const filterJoinedAtTo = ref('')
const filterLastPaymentAtFrom = ref('')
const filterLastPaymentAtTo = ref('')
const filterSubscriptionExpiresAtFrom = ref('')
const filterSubscriptionExpiresAtTo = ref('')

const hasActiveDateFilters = computed(() =>
  !!(filterJoinedAtFrom.value || filterJoinedAtTo.value
    || filterLastPaymentAtFrom.value || filterLastPaymentAtTo.value
    || filterSubscriptionExpiresAtFrom.value || filterSubscriptionExpiresAtTo.value)
)

// "até" deve incluir o dia inteiro (23:59:59), senão o backend trunca pra meia-noite
function endOfDay(date: string) {
  return date ? `${date}T23:59:59` : undefined
}

function dateFilterParams() {
  return {
    joinedAtFrom: filterJoinedAtFrom.value || undefined,
    joinedAtTo: endOfDay(filterJoinedAtTo.value),
    lastPaymentAtFrom: filterLastPaymentAtFrom.value || undefined,
    lastPaymentAtTo: endOfDay(filterLastPaymentAtTo.value),
    subscriptionExpiresAtFrom: filterSubscriptionExpiresAtFrom.value || undefined,
    subscriptionExpiresAtTo: endOfDay(filterSubscriptionExpiresAtTo.value),
  }
}

function clearDateFilters() {
  filterJoinedAtFrom.value = ''
  filterJoinedAtTo.value = ''
  filterLastPaymentAtFrom.value = ''
  filterLastPaymentAtTo.value = ''
  filterSubscriptionExpiresAtFrom.value = ''
  filterSubscriptionExpiresAtTo.value = ''
  onFilterChange()
}

let searchTableDebounce: ReturnType<typeof setTimeout>
watch(filterSearch, (term) => {
  clearTimeout(searchTableDebounce)
  searchTableDebounce = setTimeout(() => {
    reloadAndGetAll({
      perPage: perPage.value,
      search: term.trim() || undefined,
      groupId: activeGroupId.value,
      paymentPlanId: activePaymentPlanId.value,
      subscriptionStatus: activeSubscriptionStatus.value,
      ...dateFilterParams(),
    })
  }, 300)
})

// Lead detail dialog
const selectedLead = ref<ILead>()
const isShowLeadDialogOpen = ref(false)
const renewingSubscriptionId = ref<number | undefined>()
const revokingSubscriptionId = ref<number | undefined>()
const revokeTargetSubId = ref<number | undefined>()

// Create subscription dialog
const isCreateSubscriptionDialogOpen = ref(false)
const isCreatingSubscription = ref(false)

// Multi-select: leads
const selectedLeadIds = ref<number[]>([])
const selectedLeadNames = ref<string[]>([])
const searchLead = ref('')
const isLeadComboboxOpen = ref(false)

// Multi-select: groups
const selectedGroupIds = ref<number[]>([])
const selectedGroupNames = ref<string[]>([])
const searchGroup = ref('')
const isGroupComboboxOpen = ref(false)

// Form simple fields
const createFormPaymentPlanId = ref('0')
const createFormExpiresAt = ref('')

// Server-side search for leads combobox
const searchedLeads = ref<ILead[]>([])
const isSearchingLeads = ref(false)
let searchLeadsDebounce: ReturnType<typeof setTimeout>

watch(searchLead, (term) => {
  clearTimeout(searchLeadsDebounce)
  if (!term.trim()) {
    searchedLeads.value = []
    isSearchingLeads.value = false
    return
  }
  isSearchingLeads.value = true
  searchLeadsDebounce = setTimeout(async () => {
    try {
      const result = await getAllLeads({ search: term, perPage: '25' })
      searchedLeads.value = result.data
    } finally {
      isSearchingLeads.value = false
    }
  }, 300)
})

// Computed: filter out already-selected items
const filteredLeadsForCombobox = computed(() =>
  searchedLeads.value.filter(l => !selectedLeadIds.value.includes(l.id))
)
const filteredGroupsForCombobox = computed(() =>
  (groups.value?.data ?? []).filter(g => !selectedGroupIds.value.includes(g.id))
)

const leadLabel = (lead: ILead) =>
  `${lead.firstName}${lead.lastName ? ' ' + lead.lastName : ''}${lead.username ? ' (@' + lead.username + ')' : ''}`

const removeSelectedLead = (index: number) => {
  selectedLeadIds.value.splice(index, 1)
  selectedLeadNames.value.splice(index, 1)
}
const removeSelectedGroup = (index: number) => {
  selectedGroupIds.value.splice(index, 1)
  selectedGroupNames.value.splice(index, 1)
}

// Navigation
const goToChat = (lead: ILead) => {
  router.push({ name: 'chats', query: { search: lead.username || lead.firstName } })
}

const onFilterChange = () => {
  activeGroupId.value = filterGroupId.value !== '0' ? Number(filterGroupId.value) : undefined
  activePaymentPlanId.value = filterPaymentPlanId.value !== '0' ? Number(filterPaymentPlanId.value) : undefined
  activeSubscriptionStatus.value = filterSubscriptionStatus.value !== 'all' ? filterSubscriptionStatus.value : undefined
  reloadAndGetAll({
    perPage: perPage.value,
    search: filterSearch.value.trim() || undefined,
    groupId: activeGroupId.value,
    paymentPlanId: activePaymentPlanId.value,
    subscriptionStatus: activeSubscriptionStatus.value,
    ...dateFilterParams(),
  })
}

const clearFilters = () => {
  filterSearch.value = ''
  filterGroupId.value = '0'
  filterPaymentPlanId.value = '0'
  filterSubscriptionStatus.value = 'all'
  filterJoinedAtFrom.value = ''
  filterJoinedAtTo.value = ''
  filterLastPaymentAtFrom.value = ''
  filterLastPaymentAtTo.value = ''
  filterSubscriptionExpiresAtFrom.value = ''
  filterSubscriptionExpiresAtTo.value = ''
  onFilterChange()
}

const reloadAndGetAll = (params: GetAllLeadsParams) => {
  leads.value = undefined
  getAllLeads(params).then((data) => (leads.value = data))
}

const showLead = async (id: number) => {
  selectedLead.value = undefined
  isShowLeadDialogOpen.value = true
  selectedLead.value = await getById(id)
}

const renewSubscription = async (subscriptionId: number) => {
  renewingSubscriptionId.value = subscriptionId
  try {
    await renew(subscriptionId)
    toast({ title: 'Assinatura renovada com sucesso!' })
    if (selectedLead.value) {
      selectedLead.value = await getById(selectedLead.value.id)
    }
    reloadAndGetAll({ perPage: perPage.value, search: filterSearch.value.trim() || undefined, groupId: activeGroupId.value, paymentPlanId: activePaymentPlanId.value, subscriptionStatus: activeSubscriptionStatus.value, ...dateFilterParams() })
  } catch {
    toast({ title: 'Erro ao renovar assinatura', variant: 'destructive' })
  } finally {
    renewingSubscriptionId.value = undefined
  }
}

const revokeSubscription = async () => {
  if (!revokeTargetSubId.value) return
  const subscriptionId = revokeTargetSubId.value
  revokingSubscriptionId.value = subscriptionId
  revokeTargetSubId.value = undefined
  try {
    await revoke(subscriptionId)
    toast({ title: 'Assinatura revogada com sucesso!' })
    if (selectedLead.value) {
      selectedLead.value = await getById(selectedLead.value.id)
    }
    reloadAndGetAll({ perPage: perPage.value, search: filterSearch.value.trim() || undefined, groupId: activeGroupId.value, paymentPlanId: activePaymentPlanId.value, subscriptionStatus: activeSubscriptionStatus.value, ...dateFilterParams() })
  } catch {
    toast({ title: 'Erro ao revogar assinatura', variant: 'destructive' })
  } finally {
    revokingSubscriptionId.value = undefined
  }
}

const openCreateSubscriptionDialog = (leadId?: number) => {
  selectedLeadIds.value = []
  selectedLeadNames.value = []
  selectedGroupIds.value = []
  selectedGroupNames.value = []
  createFormPaymentPlanId.value = '0'
  createFormExpiresAt.value = ''
  searchLead.value = ''
  searchGroup.value = ''
  searchedLeads.value = []

  if (leadId) {
    const lead = leads.value?.data.find(l => l.id === leadId)
    if (lead) {
      selectedLeadIds.value = [lead.id]
      selectedLeadNames.value = [leadLabel(lead)]
    }
  }

  isCreateSubscriptionDialogOpen.value = true
}

const submitCreateSubscription = async () => {
  if (selectedLeadIds.value.length === 0 || selectedGroupIds.value.length === 0) {
    toast({ title: 'Selecione pelo menos um lead e um grupo', variant: 'destructive' })
    return
  }

  isCreatingSubscription.value = true
  try {
    await createManual({
      leadIds: selectedLeadIds.value,
      groupIds: selectedGroupIds.value,
      paymentPlanId: createFormPaymentPlanId.value !== '0' ? Number(createFormPaymentPlanId.value) : undefined,
      expiresAt: createFormExpiresAt.value || undefined,
    })

    const count = selectedLeadIds.value.length * selectedGroupIds.value.length
    toast({ title: `${count} assinatura(s) criada(s) com sucesso!` })
    isCreateSubscriptionDialogOpen.value = false

    if (isShowLeadDialogOpen.value && selectedLead.value) {
      selectedLead.value = await getById(selectedLead.value.id)
    }
    reloadAndGetAll({ perPage: perPage.value, search: filterSearch.value.trim() || undefined, groupId: activeGroupId.value, paymentPlanId: activePaymentPlanId.value, subscriptionStatus: activeSubscriptionStatus.value, ...dateFilterParams() })
  } catch {
    toast({ title: 'Erro ao criar assinatura(s)', variant: 'destructive' })
  } finally {
    isCreatingSubscription.value = false
  }
}

watch(
  () => perPage.value,
  () => reloadAndGetAll({ perPage: perPage.value, search: filterSearch.value.trim() || undefined, groupId: activeGroupId.value, paymentPlanId: activePaymentPlanId.value, subscriptionStatus: activeSubscriptionStatus.value, ...dateFilterParams() })
)

onMounted(async () => {
  getAllLeads().then((data) => (leads.value = data))
  getAllGroups({ perPage: '100' }).then((data) => (groups.value = data))
  getAllPaymentPlans({ perPage: '100' }).then((data) => (paymentPlans.value = data))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createVNode(PageTitle, null, {
          default: _withCtx(() => _cache[34] || (_cache[34] = [
            _createTextVNode("Gerencie seus usuários")
          ])),
          _: 1
        }),
        _createVNode(PageDescription, null, {
          default: _withCtx(() => _cache[35] || (_cache[35] = [
            _createTextVNode(" Tenha acesso a todas as pessoas que entraram em contato com o seu bot. ")
          ])),
          _: 1
        })
      ]),
      _createVNode(_unref(Button), {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (openCreateSubscriptionDialog()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(Plus), { class: "h-4 w-4 mr-2" }),
          _cache[36] || (_cache[36] = _createTextVNode(" Nova assinatura "))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
          default: _withCtx(() => _cache[37] || (_cache[37] = [
            _createTextVNode("Buscar")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_unref(Search), { class: "absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-zinc-400 pointer-events-none" }),
          _createVNode(_unref(Input), {
            modelValue: filterSearch.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filterSearch).value = $event)),
            placeholder: "Nome, usuário...",
            class: "pl-9 w-[220px]"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
          default: _withCtx(() => _cache[38] || (_cache[38] = [
            _createTextVNode("Grupo")
          ])),
          _: 1
        }),
        _createVNode(_unref(Select), {
          modelValue: filterGroupId.value,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((filterGroupId).value = $event)),
            onFilterChange
          ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectTrigger), { class: "w-[200px]" }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectValue), { placeholder: "Todos os grupos" })
              ]),
              _: 1
            }),
            _createVNode(_unref(SelectContent), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectItem), { value: "0" }, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode("Todos os grupos")
                  ])),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value?.data, (group) => {
                  return (_openBlock(), _createBlock(_unref(SelectItem), {
                    key: group.id,
                    value: String(group.id)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(group.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
          default: _withCtx(() => _cache[40] || (_cache[40] = [
            _createTextVNode("Plano de pagamento")
          ])),
          _: 1
        }),
        _createVNode(_unref(Select), {
          modelValue: filterPaymentPlanId.value,
          "onUpdate:modelValue": [
            _cache[3] || (_cache[3] = ($event: any) => ((filterPaymentPlanId).value = $event)),
            onFilterChange
          ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectTrigger), { class: "w-[220px]" }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectValue), { placeholder: "Todos os planos" })
              ]),
              _: 1
            }),
            _createVNode(_unref(SelectContent), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectItem), { value: "0" }, {
                  default: _withCtx(() => _cache[41] || (_cache[41] = [
                    _createTextVNode("Todos os planos")
                  ])),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlans.value?.data, (plan) => {
                  return (_openBlock(), _createBlock(_unref(SelectItem), {
                    key: plan.id,
                    value: String(plan.id)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(plan.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
          default: _withCtx(() => _cache[42] || (_cache[42] = [
            _createTextVNode("Assinatura")
          ])),
          _: 1
        }),
        _createVNode(_unref(Select), {
          modelValue: filterSubscriptionStatus.value,
          "onUpdate:modelValue": [
            _cache[4] || (_cache[4] = ($event: any) => ((filterSubscriptionStatus).value = $event)),
            onFilterChange
          ]
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SelectTrigger), { class: "w-[200px]" }, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectValue), { placeholder: "Todos" })
              ]),
              _: 1
            }),
            _createVNode(_unref(SelectContent), null, {
              default: _withCtx(() => [
                _createVNode(_unref(SelectItem), { value: "all" }, {
                  default: _withCtx(() => _cache[43] || (_cache[43] = [
                    _createTextVNode("Todos")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(SelectItem), { value: "active" }, {
                  default: _withCtx(() => _cache[44] || (_cache[44] = [
                    _createTextVNode("Assinantes ativos")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(SelectItem), { value: "inactive" }, {
                  default: _withCtx(() => _cache[45] || (_cache[45] = [
                    _createTextVNode("Assinantes inativos")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
          default: _withCtx(() => _cache[46] || (_cache[46] = [
            _createTextVNode("Período")
          ])),
          _: 1
        }),
        _createVNode(_unref(Popover), null, {
          default: _withCtx(() => [
            _createVNode(_unref(PopoverTrigger), { "as-child": "" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  variant: "outline",
                  class: "w-[200px] justify-start text-left font-normal"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(CalendarIcon), { class: "h-4 w-4 mr-2" }),
                    (hasActiveDateFilters.value)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Filtros de data ativos"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_11, "Filtrar por período"))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_unref(PopoverContent), { class: "w-[min(420px,calc(100vw-2rem))] space-y-4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
                    default: _withCtx(() => _cache[47] || (_cache[47] = [
                      _createTextVNode("Data de entrada")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_unref(Input), {
                      modelValue: filterJoinedAtFrom.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((filterJoinedAtFrom).value = $event)),
                      type: "date",
                      class: "min-w-0 flex-1"
                    }, null, 8, ["modelValue"]),
                    _cache[48] || (_cache[48] = _createElementVNode("span", { class: "shrink-0 text-zinc-500 text-xs" }, "até", -1)),
                    _createVNode(_unref(Input), {
                      modelValue: filterJoinedAtTo.value,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((filterJoinedAtTo).value = $event)),
                      type: "date",
                      class: "min-w-0 flex-1"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
                    default: _withCtx(() => _cache[49] || (_cache[49] = [
                      _createTextVNode("Último pagamento")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_unref(Input), {
                      modelValue: filterLastPaymentAtFrom.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((filterLastPaymentAtFrom).value = $event)),
                      type: "date",
                      class: "min-w-0 flex-1"
                    }, null, 8, ["modelValue"]),
                    _cache[50] || (_cache[50] = _createElementVNode("span", { class: "shrink-0 text-zinc-500 text-xs" }, "até", -1)),
                    _createVNode(_unref(Input), {
                      modelValue: filterLastPaymentAtTo.value,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((filterLastPaymentAtTo).value = $event)),
                      type: "date",
                      class: "min-w-0 flex-1"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_unref(Label), { class: "text-xs text-zinc-400 uppercase tracking-wider" }, {
                    default: _withCtx(() => _cache[51] || (_cache[51] = [
                      _createTextVNode("Saída (expiração)")
                    ])),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_unref(Input), {
                      modelValue: filterSubscriptionExpiresAtFrom.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((filterSubscriptionExpiresAtFrom).value = $event)),
                      type: "date",
                      class: "min-w-0 flex-1"
                    }, null, 8, ["modelValue"]),
                    _cache[52] || (_cache[52] = _createElementVNode("span", { class: "shrink-0 text-zinc-500 text-xs" }, "até", -1)),
                    _createVNode(_unref(Input), {
                      modelValue: filterSubscriptionExpiresAtTo.value,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((filterSubscriptionExpiresAtTo).value = $event)),
                      type: "date",
                      class: "min-w-0 flex-1"
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "sm",
                    class: "text-zinc-400 hover:text-white",
                    onClick: clearDateFilters
                  }, {
                    default: _withCtx(() => _cache[53] || (_cache[53] = [
                      _createTextVNode(" Limpar datas ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_unref(Button), {
                    size: "sm",
                    onClick: onFilterChange
                  }, {
                    default: _withCtx(() => _cache[54] || (_cache[54] = [
                      _createTextVNode("Aplicar")
                    ])),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      (filterSearch.value || filterGroupId.value !== '0' || filterPaymentPlanId.value !== '0' || filterSubscriptionStatus.value !== 'all' || hasActiveDateFilters.value)
        ? (_openBlock(), _createBlock(_unref(Button), {
            key: 0,
            variant: "ghost",
            size: "sm",
            class: "text-zinc-400 hover:text-white",
            onClick: clearFilters
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(X), { class: "h-4 w-4 mr-1" }),
              _cache[55] || (_cache[55] = _createTextVNode(" Limpar filtros "))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createVNode(TableContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _cache[56] || (_cache[56] = _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Usuários registrados", -1)),
          _createElementVNode("div", _hoisted_20, "Total: " + _toDisplayString(leads.value?.pagination?.total), 1)
        ]),
        _createVNode(Table, { class: "hidden md:block" }, {
          default: _withCtx(() => [
            _createVNode(TableHeader, null, {
              default: _withCtx(() => [
                _createVNode(TableRow, null, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                      return _createVNode(TableHead, {
                        key: header.key,
                        class: _normalizeClass(header.class)
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_21, [
                            _createTextVNode(_toDisplayString(header.label) + " ", 1),
                            (header.sortable)
                              ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                  key: 0,
                                  class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white"
                                }))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["class"])
                    }), 64))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(TableBody, null, {
              default: _withCtx(() => [
                (leads.value)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (leads.value.data.length === 0)
                        ? (_openBlock(), _createBlock(TableFallback, {
                            key: 0,
                            colspan: tableHeaders.length,
                            icon: _unref(Contact),
                            title: "Nenhum lead encontrado",
                            description: "Aguarde e volte novamente mais tarde"
                          }, null, 8, ["colspan", "icon"]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leads.value.data, (lead) => {
                        return (_openBlock(), _createBlock(TableRow, {
                          key: lead.id
                        }, {
                          default: _withCtx(() => [
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, _toDisplayString(lead.firstName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(lead.lastName), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_24, _toDisplayString(lead.username), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(lead.isBuyer ? 'Sim' : 'Não'), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "text-sm" }, {
                              default: _withCtx(() => [
                                _createVNode(LeadStatusBadge, {
                                  status: lead.isSubscriber ? lead.isActiveSubscriber ? 'activeSubscriber' : 'inactiveSubscriber' : 'nonSubscriber'
                                }, null, 8, ["status"])
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_26, _toDisplayString(formatDate(lead.joinedAt)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_27, _toDisplayString(formatDate(lead.lastPaymentAt)), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, { class: "whitespace-nowrap" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", {
                                  class: _normalizeClass(["text-sm", lead.subscriptionExpiresAt && !lead.isActiveSubscriber ? 'text-red-400' : 'text-zinc-300'])
                                }, _toDisplayString(formatDate(lead.subscriptionExpiresAt)), 3)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(TableCell, null, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_unref(Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    title: "Ver detalhes",
                                    onClick: ($event: any) => (showLead(lead.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(Eye), { class: "h-4 w-4" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_unref(Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    title: "Nova assinatura",
                                    onClick: ($event: any) => (openCreateSubscriptionDialog(lead.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(PlusCircle), { class: "h-4 w-4" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_unref(Button), {
                                    variant: "ghost",
                                    size: "icon",
                                    title: "Ir para chat",
                                    onClick: ($event: any) => (goToChat(lead))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_unref(MessageCircle), { class: "h-4 w-4" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ], 64))
                  : (_openBlock(), _createBlock(TableRowSkeleton, {
                      key: 1,
                      columns: tableHeaders.length
                    }, null, 8, ["columns"]))
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (leads.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
              (leads.value.data.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(leads.value.data, (lead) => {
                    return (_openBlock(), _createBlock(MobileCard, {
                      key: lead.id
                    }, {
                      header: _withCtx(() => [
                        _createElementVNode("div", _hoisted_30, [
                          _cache[57] || (_cache[57] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Lead", -1)),
                          _createElementVNode("span", _hoisted_31, _toDisplayString(lead.firstName) + " " + _toDisplayString(lead.lastName), 1)
                        ])
                      ]),
                      actions: _withCtx(() => [
                        _createElementVNode("div", _hoisted_32, [
                          _createElementVNode("button", {
                            onClick: ($event: any) => (goToChat(lead)),
                            class: "text-zinc-400 hover:text-white p-1"
                          }, [
                            _createVNode(_unref(MessageCircle), { class: "size-5" })
                          ], 8, _hoisted_33),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (openCreateSubscriptionDialog(lead.id)),
                            class: "text-zinc-400 hover:text-white p-1"
                          }, [
                            _createVNode(_unref(PlusCircle), { class: "size-5" })
                          ], 8, _hoisted_34),
                          _createElementVNode("button", {
                            onClick: ($event: any) => (showLead(lead.id)),
                            class: "text-zinc-400 hover:text-white p-1"
                          }, [
                            _createVNode(_unref(Eye), { class: "size-5" })
                          ], 8, _hoisted_35)
                        ])
                      ]),
                      content: _withCtx(() => [
                        _createVNode(MobileDataLabel, { label: "Usuário" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(lead.username), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createElementVNode("div", _hoisted_36, [
                          _createElementVNode("div", _hoisted_37, [
                            _cache[58] || (_cache[58] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Comprador", -1)),
                            _createElementVNode("div", _hoisted_38, _toDisplayString(lead.isBuyer ? 'Sim' : 'Não'), 1)
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _cache[59] || (_cache[59] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider mb-1" }, "Assinatura", -1)),
                            _createVNode(LeadStatusBadge, {
                              status: lead.isSubscriber ? lead.isActiveSubscriber ? 'activeSubscriber' : 'inactiveSubscriber' : 'nonSubscriber'
                            }, null, 8, ["status"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createVNode(MobileDataLabel, { label: "Data de entrada" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatDate(lead.joinedAt)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Último pagamento" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatDate(lead.lastPaymentAt)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Saída" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(formatDate(lead.subscriptionExpiresAt)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_41, [
                    _createVNode(_unref(Contact), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                    _cache[60] || (_cache[60] = _createTextVNode(" Nenhum lead encontrado "))
                  ]))
            ]))
          : _createCommentVNode("", true),
        (leads.value?.pagination)
          ? (_openBlock(), _createBlock(Pagination, {
              key: 1,
              "onUpdate:page": _cache[11] || (_cache[11] = page => reloadAndGetAll({ page, perPage: perPage.value, groupId: activeGroupId.value, paymentPlanId: activePaymentPlanId.value })),
              data: leads.value?.pagination,
              "per-page": perPage.value,
              "onUpdate:perPage": _cache[12] || (_cache[12] = ($event: any) => ((perPage).value = $event))
            }, null, 8, ["data", "per-page"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_unref(Dialog), {
      open: isShowLeadDialogOpen.value,
      "onUpdate:open": _cache[15] || (_cache[15] = ($event: any) => ((isShowLeadDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-4xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode("Usuário: " + _toDisplayString(selectedLead.value?.firstName) + " " + _toDisplayString(selectedLead.value?.lastName), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[61] || (_cache[61] = [
                    _createTextVNode("Monitore as informações do seu usuário.")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            (selectedLead.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _cache[64] || (_cache[64] = _createElementVNode("h4", { class: "text-xl font-semibold text-white" }, "Assinaturas de grupos", -1)),
                    _createElementVNode("div", _hoisted_44, [
                      _createVNode(_unref(Button), {
                        size: "sm",
                        variant: "ghost",
                        class: "text-white",
                        title: "Ir para chat",
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (goToChat(selectedLead.value)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(MessageCircle), { class: "h-4 w-4 mr-1" }),
                          _cache[62] || (_cache[62] = _createTextVNode(" Chat "))
                        ]),
                        _: 1
                      }),
                      _createVNode(_unref(Button), {
                        size: "sm",
                        variant: "outline",
                        class: "text-white",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (openCreateSubscriptionDialog(selectedLead.value.id)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Plus), { class: "h-4 w-4 mr-1" }),
                          _cache[63] || (_cache[63] = _createTextVNode(" Adicionar "))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(Table, null, {
                      default: _withCtx(() => [
                        _createVNode(TableHeader, null, {
                          default: _withCtx(() => [
                            _createVNode(TableRow, null, {
                              default: _withCtx(() => [
                                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(groupSubscriptionTableHeaders, (header) => {
                                  return _createVNode(TableHead, {
                                    key: header.key
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(header.label), 1)
                                    ]),
                                    _: 2
                                  }, 1024)
                                }), 64))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(TableBody, null, {
                          default: _withCtx(() => [
                            (selectedLead.value.groupSubscriptions.length === 0)
                              ? (_openBlock(), _createBlock(TableFallback, {
                                  key: 0,
                                  colspan: groupSubscriptionTableHeaders.length,
                                  icon: _unref(CreditCard),
                                  title: "Nenhuma assinatura encontrada",
                                  description: "Clique em Adicionar para criar uma."
                                }, null, 8, ["colspan", "icon"]))
                              : _createCommentVNode("", true),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLead.value.groupSubscriptions, (sub) => {
                              return (_openBlock(), _createBlock(TableRow, {
                                key: sub.id
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(TableCell, { class: "max-w-[160px]" }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_46, _toDisplayString(sub.group?.name), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(TableCell, { class: "whitespace-nowrap" }, {
                                    default: _withCtx(() => [
                                      (sub.expiresAt)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(new Date(sub.expiresAt).toLocaleString('pt-BR')), 1))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_48, "Vitalício"))
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(TableCell, null, {
                                    default: _withCtx(() => [
                                      _createVNode(StatusBadge, {
                                        status: sub.hasAccess ? 'active' : 'inactive'
                                      }, null, 8, ["status"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(TableCell, null, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_49, [
                                        _createVNode(_unref(Button), {
                                          variant: "ghost",
                                          size: "sm",
                                          class: "text-white",
                                          disabled: renewingSubscriptionId.value === sub.id || revokingSubscriptionId.value === sub.id,
                                          onClick: ($event: any) => (renewSubscription(sub.id)),
                                          title: "Renovar assinatura"
                                        }, {
                                          default: _withCtx(() => [
                                            (renewingSubscriptionId.value === sub.id)
                                              ? (_openBlock(), _createBlock(_unref(Loader2), {
                                                  key: 0,
                                                  class: "h-4 w-4 animate-spin"
                                                }))
                                              : (_openBlock(), _createBlock(_unref(RefreshCw), {
                                                  key: 1,
                                                  class: "h-4 w-4"
                                                })),
                                            _cache[65] || (_cache[65] = _createElementVNode("span", { class: "ml-1 hidden sm:inline" }, "Renovar", -1))
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"]),
                                        _createVNode(_unref(Button), {
                                          variant: "ghost",
                                          size: "sm",
                                          disabled: !sub.hasAccess || revokingSubscriptionId.value === sub.id || renewingSubscriptionId.value === sub.id,
                                          class: "text-red-400 hover:text-red-300 hover:bg-red-950/40 disabled:opacity-40",
                                          onClick: ($event: any) => (revokeTargetSubId.value = sub.id),
                                          title: "Revogar assinatura"
                                        }, {
                                          default: _withCtx(() => [
                                            (revokingSubscriptionId.value === sub.id)
                                              ? (_openBlock(), _createBlock(_unref(Loader2), {
                                                  key: 0,
                                                  class: "h-4 w-4 animate-spin"
                                                }))
                                              : (_openBlock(), _createBlock(_unref(ShieldOff), {
                                                  key: 1,
                                                  class: "h-4 w-4"
                                                })),
                                            _cache[66] || (_cache[66] = _createElementVNode("span", { class: "ml-1 hidden sm:inline" }, "Revogar", -1))
                                          ]),
                                          _: 2
                                        }, 1032, ["disabled", "onClick"])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ])
                ]))
              : (_openBlock(), _createBlock(_unref(Loader2), {
                  key: 1,
                  class: "w-10 h-10 animate-spin text-white mx-auto"
                }))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(Dialog), {
      open: isCreateSubscriptionDialogOpen.value,
      "onUpdate:open": _cache[31] || (_cache[31] = ($event: any) => ((isCreateSubscriptionDialogOpen).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-lg" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => _cache[67] || (_cache[67] = [
                    _createTextVNode("Nova assinatura de grupo")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[68] || (_cache[68] = [
                    _createTextVNode(" Crie assinaturas para um ou mais leads em um ou mais grupos. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("form", {
              onSubmit: _withModifiers(submitCreateSubscription, ["prevent"]),
              class: "space-y-5 py-4"
            }, [
              _createElementVNode("div", _hoisted_50, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[69] || (_cache[69] = [
                    _createTextVNode("Leads "),
                    _createElementVNode("span", { class: "text-red-400" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(TagsInput), {
                  class: "px-0 gap-0 w-full",
                  "model-value": selectedLeadNames.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_51, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLeadNames.value, (name, i) => {
                        return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                          key: i,
                          value: name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TagsInputItemText)),
                            _createVNode(_unref(TagsInputItemDelete), {
                              onClick: ($event: any) => (removeSelectedLead(i))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _createVNode(_unref(ComboboxRoot), {
                      modelValue: selectedLeadNames.value,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((selectedLeadNames).value = $event)),
                      open: isLeadComboboxOpen.value,
                      "onUpdate:open": _cache[20] || (_cache[20] = ($event: any) => ((isLeadComboboxOpen).value = $event)),
                      "search-term": searchLead.value,
                      "onUpdate:searchTerm": _cache[21] || (_cache[21] = ($event: any) => ((searchLead).value = $event)),
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ComboboxInput), {
                              placeholder: "Buscar lead...",
                              "as-child": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(TagsInputInput), {
                                  onFocus: _cache[16] || (_cache[16] = ($event: any) => (isLeadComboboxOpen.value = true)),
                                  class: _normalizeClass(["w-full px-3", selectedLeadIds.value.length > 0 ? 'mt-2' : '']),
                                  onKeydown: _cache[17] || (_cache[17] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                }, null, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(ComboboxPortal), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ComboboxContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CommandList), {
                                  position: "popper",
                                  class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 z-50"
                                }, {
                                  default: _withCtx(() => [
                                    (isSearchingLeads.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                          _createVNode(_unref(Loader2), { class: "h-4 w-4 animate-spin mx-auto" })
                                        ]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          (searchLead.value.trim())
                                            ? (_openBlock(), _createBlock(_unref(CommandEmpty), { key: 0 }, {
                                                default: _withCtx(() => _cache[70] || (_cache[70] = [
                                                  _createTextVNode("Nenhum lead encontrado")
                                                ])),
                                                _: 1
                                              }))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_53, " Digite para buscar leads... ")),
                                          (filteredLeadsForCombobox.value.length > 0)
                                            ? (_openBlock(), _createBlock(_unref(CommandGroup), { key: 2 }, {
                                                default: _withCtx(() => [
                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLeadsForCombobox.value, (lead) => {
                                                    return (_openBlock(), _createBlock(_unref(CommandItem), {
                                                      key: lead.id,
                                                      value: leadLabel(lead),
                                                      onSelect: _cache[18] || (_cache[18] = _withModifiers((ev) => {
                              if (typeof ev.detail.value === 'string') {
                                searchLead.value = ''
                                const l = filteredLeadsForCombobox.value.find(x => leadLabel(x) === ev.detail.value)
                                if (l) { selectedLeadIds.value.push(l.id); selectedLeadNames.value.push(leadLabel(l)) }
                              }
                            }, ["prevent"]))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(leadLabel(lead)), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["value"]))
                                                  }), 128))
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "open", "search-term"])
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _cache[71] || (_cache[71] = _createElementVNode("p", { class: "text-xs text-zinc-500" }, "Você pode selecionar mais de 1 lead", -1))
              ]),
              _createElementVNode("div", _hoisted_54, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[72] || (_cache[72] = [
                    _createTextVNode("Grupos "),
                    _createElementVNode("span", { class: "text-red-400" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(TagsInput), {
                  class: "px-0 gap-0 w-full",
                  "model-value": selectedGroupNames.value
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_55, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedGroupNames.value, (name, i) => {
                        return (_openBlock(), _createBlock(_unref(TagsInputItem), {
                          key: i,
                          value: name
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(TagsInputItemText)),
                            _createVNode(_unref(TagsInputItemDelete), {
                              onClick: ($event: any) => (removeSelectedGroup(i))
                            }, null, 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["value"]))
                      }), 128))
                    ]),
                    _createVNode(_unref(ComboboxRoot), {
                      modelValue: selectedGroupNames.value,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((selectedGroupNames).value = $event)),
                      open: isGroupComboboxOpen.value,
                      "onUpdate:open": _cache[26] || (_cache[26] = ($event: any) => ((isGroupComboboxOpen).value = $event)),
                      "search-term": searchGroup.value,
                      "onUpdate:searchTerm": _cache[27] || (_cache[27] = ($event: any) => ((searchGroup).value = $event)),
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(ComboboxAnchor), { "as-child": "" }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ComboboxInput), {
                              placeholder: "Buscar grupo...",
                              "as-child": ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(TagsInputInput), {
                                  onFocus: _cache[22] || (_cache[22] = ($event: any) => (isGroupComboboxOpen.value = true)),
                                  class: _normalizeClass(["w-full px-3", selectedGroupIds.value.length > 0 ? 'mt-2' : '']),
                                  onKeydown: _cache[23] || (_cache[23] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                                }, null, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_unref(ComboboxPortal), null, {
                          default: _withCtx(() => [
                            _createVNode(_unref(ComboboxContent), null, {
                              default: _withCtx(() => [
                                _createVNode(_unref(CommandList), {
                                  position: "popper",
                                  class: "w-[--radix-popper-anchor-width] rounded-md mt-2 border bg-popover text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 z-50"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(CommandEmpty), null, {
                                      default: _withCtx(() => _cache[73] || (_cache[73] = [
                                        _createTextVNode("Nenhum grupo encontrado")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_unref(CommandGroup), null, {
                                      default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroupsForCombobox.value, (group) => {
                                          return (_openBlock(), _createBlock(_unref(CommandItem), {
                                            key: group.id,
                                            value: group.name,
                                            onSelect: _cache[24] || (_cache[24] = _withModifiers((ev) => {
                            if (typeof ev.detail.value === 'string') {
                              searchGroup.value = ''
                              const g = filteredGroupsForCombobox.value.find(x => x.name === ev.detail.value)
                              if (g) { selectedGroupIds.value.push(g.id); selectedGroupNames.value.push(g.name) }
                            }
                            if (filteredGroupsForCombobox.value.length === 0) isGroupComboboxOpen.value = false
                          }, ["prevent"]))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(group.name), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["value"]))
                                        }), 128))
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue", "open", "search-term"])
                  ]),
                  _: 1
                }, 8, ["model-value"]),
                _cache[74] || (_cache[74] = _createElementVNode("p", { class: "text-xs text-zinc-500" }, "Você pode selecionar mais de 1 grupo", -1))
              ]),
              _createElementVNode("div", _hoisted_56, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[75] || (_cache[75] = [
                    _createTextVNode(" Plano de pagamento "),
                    _createElementVNode("span", { class: "text-zinc-500 text-xs ml-1" }, "(opcional)", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Select), {
                  modelValue: createFormPaymentPlanId.value,
                  "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((createFormPaymentPlanId).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SelectTrigger), { class: "w-full" }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectValue), { placeholder: "Sem plano" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(SelectContent), null, {
                      default: _withCtx(() => [
                        _createVNode(_unref(SelectItem), { value: "0" }, {
                          default: _withCtx(() => _cache[76] || (_cache[76] = [
                            _createTextVNode("Sem plano")
                          ])),
                          _: 1
                        }),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paymentPlans.value?.data, (plan) => {
                          return (_openBlock(), _createBlock(_unref(SelectItem), {
                            key: plan.id,
                            value: String(plan.id)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(plan.name), 1)
                            ]),
                            _: 2
                          }, 1032, ["value"]))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_57, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[77] || (_cache[77] = [
                    _createTextVNode(" Data de expiração "),
                    _createElementVNode("span", { class: "text-zinc-500 text-xs ml-1" }, "(vazio = vitalício)", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: createFormExpiresAt.value,
                  "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((createFormExpiresAt).value = $event)),
                  type: "datetime-local"
                }, null, 8, ["modelValue"])
              ]),
              (selectedLeadIds.value.length > 0 && selectedGroupIds.value.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _cache[78] || (_cache[78] = _createTextVNode(" Serão criadas ")),
                    _createElementVNode("span", _hoisted_59, _toDisplayString(selectedLeadIds.value.length * selectedGroupIds.value.length), 1),
                    _cache[79] || (_cache[79] = _createTextVNode(" assinatura(s) para ")),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(selectedLeadIds.value.length), 1),
                    _cache[80] || (_cache[80] = _createTextVNode(" lead(s) em ")),
                    _createElementVNode("span", _hoisted_61, _toDisplayString(selectedGroupIds.value.length), 1),
                    _cache[81] || (_cache[81] = _createTextVNode(" grupo(s). "))
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_62, [
                _createVNode(_unref(Button), {
                  type: "button",
                  variant: "ghost",
                  onClick: _cache[30] || (_cache[30] = ($event: any) => (isCreateSubscriptionDialogOpen.value = false))
                }, {
                  default: _withCtx(() => _cache[82] || (_cache[82] = [
                    _createTextVNode(" Cancelar ")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  type: "submit",
                  disabled: isCreatingSubscription.value || selectedLeadIds.value.length === 0 || selectedGroupIds.value.length === 0
                }, {
                  default: _withCtx(() => [
                    (isCreatingSubscription.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "h-4 w-4 mr-2 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" Criar " + _toDisplayString(selectedLeadIds.value.length * selectedGroupIds.value.length > 1 ? `${selectedLeadIds.value.length * selectedGroupIds.value.length} assinaturas` : 'assinatura'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_unref(Dialog), {
      open: !!revokeTargetSubId.value,
      "onUpdate:open": _cache[33] || (_cache[33] = (v) => { if (!v) revokeTargetSubId.value = undefined })
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogScrollContent), { class: "sm:max-w-sm" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => _cache[83] || (_cache[83] = [
                    _createTextVNode("Revogar assinatura")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[84] || (_cache[84] = [
                    _createTextVNode(" O lead será removido do grupo e receberá uma notificação. Esta ação pode ser revertida renovando a assinatura manualmente. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_63, [
              _createVNode(_unref(Button), {
                variant: "ghost",
                onClick: _cache[32] || (_cache[32] = ($event: any) => (revokeTargetSubId.value = undefined))
              }, {
                default: _withCtx(() => _cache[85] || (_cache[85] = [
                  _createTextVNode("Cancelar")
                ])),
                _: 1
              }),
              _createVNode(_unref(Button), {
                variant: "destructive",
                disabled: !!revokingSubscriptionId.value,
                onClick: revokeSubscription
              }, {
                default: _withCtx(() => [
                  (revokingSubscriptionId.value)
                    ? (_openBlock(), _createBlock(_unref(Loader2), {
                        key: 0,
                        class: "h-4 w-4 mr-2 animate-spin"
                      }))
                    : (_openBlock(), _createBlock(_unref(ShieldOff), {
                        key: 1,
                        class: "h-4 w-4 mr-2"
                      })),
                  _cache[86] || (_cache[86] = _createTextVNode(" Revogar acesso "))
                ]),
                _: 1
              }, 8, ["disabled"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})